import {
    GET_BILLS_REQUEST, GET_BILLS_SUCCESS, GET_BILLS_FAIL,
    CREATE_BILL_REQUEST, CREATE_BILL_SUCCESS, CREATE_BILL_FAIL,
    UPDATE_BILL_REQUEST, UPDATE_BILL_SUCCESS, UPDATE_BILL_FAIL,
    DELETE_BILL_REQUEST, DELETE_BILL_SUCCESS, DELETE_BILL_FAIL
} from "../types/billTypes";
import Axios from 'axios';
import APP_CONSTANT from '../../config/constants'
import cogoToast from "cogo-toast";

export const deleteBill = (id) => async (dispatch) => {

    dispatch({ type: DELETE_BILL_REQUEST });

    try {

        const headerData = {
            "api_token": localStorage.getItem('isloggedIn'),
            "customerNo": localStorage.getItem('customerNumber'),
            "userId": localStorage.getItem('userId'),
            "billReferenceNo": id
        }

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/bill/delete`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('isloggedIn'),
                "Access-Control-Allow-Origin": "*"
            }
        });
        dispatch({ type: DELETE_BILL_SUCCESS, payload: data });
        window.location.reload()

    } catch (error) {
        dispatch({ type: DELETE_BILL_FAIL, payload: error.message })
    }
}

export const updateBill = (updateBillData) => async (dispatch) => {

    console.log("update bill called")
    dispatch({ type: UPDATE_BILL_REQUEST });

    try {

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/bill/update`, updateBillData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('isloggedIn'),
                "Access-Control-Allow-Origin": "*"
            }
        });
        dispatch({ type: UPDATE_BILL_SUCCESS, payload: data });
        if (data.status === 0) {
            cogoToast.error(data.message)
        } else {
            if(updateBillData.fileUpload){
                console.log("Filleelele", updateBillData)

                let token = localStorage.getItem('apiToken')
                let userId = localStorage.getItem('userId')
                let customerNo = localStorage.getItem('customerNumber')
                
                let uploadBillData = {
                    "customerNo": customerNo,
                    "userId": userId,
                    "billReferenceNo" : updateBillData.billReferenceNo,
                    "billFile" : updateBillData.fileUpload
                }

                Axios.post(`${APP_CONSTANT.BASE_URL}purchase/bill/uploadBill`, uploadBillData, {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                }).then((response => {
                    cogoToast.loading("Loading your data...", { position: 'top-right'}).then(() => {
                        if(response.data.status === 0){
                            cogoToast.error(response.data.message)
                        } else {
                            cogoToast.success(response.data.message)
                            window.location.href = '/bill';
                        }
                    })
                    
                }))
                    .catch(error => {
                        cogoToast.error(error.message, { position: 'top-right'})
                    })
            } else {
                cogoToast.success(data.message, { position: 'top-right'}).then(() => {
                    window.location.href = '/bill';
                })
            }
        }

    } catch (error) {
        dispatch({ type: UPDATE_BILL_FAIL, payload: error.message })
    }
}

export const createBill = (createBillData) => async (dispatch) => {

    dispatch({ type: CREATE_BILL_REQUEST });

    try {

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/bill/create`, createBillData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('isloggedIn'),
                "Access-Control-Allow-Origin": "*",
            }
        });
        console.log(data)
        dispatch({ type: CREATE_BILL_SUCCESS, payload: data });
        if (data.status === 0) {
            cogoToast.error(data.message);
        } else {

            if(createBillData.fileUpload){
                console.log("Filleelele", createBillData)

                let token = localStorage.getItem('apiToken')
                let userId = localStorage.getItem('userId')
                let customerNo = localStorage.getItem('customerNumber')
                
                let uploadBillData = {
                    "customerNo": customerNo,
                    "userId": userId,
                    "billReferenceNo" : createBillData.billReferenceNo,
                    "billFile" : createBillData.fileUpload
                }

                Axios.post(`${APP_CONSTANT.BASE_URL}purchase/bill/uploadBill`, uploadBillData, {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                }).then((response => {
                    cogoToast.loading("Loading your data...", { position: 'top-right'}).then(() => {
                        if(response.data.status === 0){
                            cogoToast.error(response.data.message)
                        } else {
                            cogoToast.success(response.data.message)
                            window.location.href = '/bill';
                        }
                    })
                    
                }))
                    .catch(error => {
                        cogoToast.error(error.message, { position: 'top-right'})
                    })
            } else {
                cogoToast.success(data.message, { position: 'top-right'}).then(() => {
                    window.location.href = '/bill';
                })
            }

        }

    } catch (error) {
        dispatch({ type: CREATE_BILL_FAIL, payload: error.message });
    };
};

export const getBills = (id) => async (dispatch) => {
    // console.log(localStorage)
    dispatch({ type: GET_BILLS_REQUEST });

    try {

        const headerData = (id) => {
            if (id) {
                return {
                    "api_token": localStorage.getItem('isloggedIn'),
                    "customerNo": localStorage.getItem('customerNumber'),
                    "userId": localStorage.getItem('userId'),
                    "billId": id,
                }
            } else {
                return {
                    "api_token": localStorage.getItem('isloggedIn'),
                    "customerNo": localStorage.getItem('customerNumber'),
                    "userId": localStorage.getItem('userId'),
                }
            }
        }

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/bill/getBills`, headerData(id), {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('isloggedIn'),
                "Access-Control-Allow-Origin": "*",
            }
        });
        dispatch({ type: GET_BILLS_SUCCESS, payload: data });


    } catch (error) {
        dispatch({ type: GET_BILLS_FAIL, payload: error.message });
    };
};


export const getVendorBills = (vendorCode) => async (dispatch) => {

    dispatch({ type: GET_BILLS_REQUEST });

    try {

        const headerData = (vendorCode) => {
            if (vendorCode) {
                return {
                    "api_token": localStorage.getItem('isloggedIn'),
                    "customerNo": localStorage.getItem('customerNumber'),
                    "userId": localStorage.getItem('userId'),
                    "vendorCode": vendorCode,
                }
            } else {
                return {
                    "api_token": localStorage.getItem('isloggedIn'),
                    "customerNo": localStorage.getItem('customerNumber'),
                    "userId": localStorage.getItem('userId'),
                }
            }
        }

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/bill/getBills`, headerData(vendorCode), {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('isloggedIn'),
                "Access-Control-Allow-Origin": "*",
            }
        });
        dispatch({ type: GET_BILLS_SUCCESS, payload: data });


    } catch (error) {
        dispatch({ type: GET_BILLS_FAIL, payload: error.message });
    };
};